module.exports = __webpack_public_path__ + "img/header_dsk.c61e440.jpg";